<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ titreModal }}
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialInput
        v-model="libelle"
        label="Libellé *"
        :class="isAbonneCulturial ? '' : 'cursor-pointer'"
        hide-details
        :readonly="!isAbonneCulturial"
      >
        <template
          v-if="!isAbonneCulturial"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialInput>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialSelect
        v-model="typeContrat"
        :items="typesContrat"
        item-text="libelle"
        label="Type de contrat *"
        return-object
        :class="isAbonneCulturial ? '' : 'cursor-pointer'"
        hide-details
        :readonly="!isAbonneCulturial"
      >
        <template
          v-if="!isAbonneCulturial"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialSelect>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialInputNumber
        v-model="poidsEnTonne"
        label="Poids *"
        return-object
        suffix="t"
        :class="isAbonneCulturial ? '' : 'cursor-pointer'"
        hide-details
        :readonly="!isAbonneCulturial"
      >
        <template
          v-if="!isAbonneCulturial"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialInputNumber>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
      @click="openModalAbonnement()"
    >
      <AgrialSelect
        v-model="typePrix"
        :items="typesPrix"
        item-text="libelle"
        label="Type de prix *"
        return-object
        :class="isAbonneCulturial ? '' : 'cursor-pointer'"
        hide-details
        :readonly="!isAbonneCulturial"
        @change="updateTypePrix"
      >
        <template
          v-if="!isAbonneCulturial"
          v-slot:prepend-inner
        >
          <v-icon
            class="prepend-icon"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
        </template>
      </AgrialSelect>
    </div>
    <div
      v-if="typePrix && typePrix.code !== 'AUCUN'"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model="prixPayeEnEuroParTonne"
        :label="typePrix.code === 'PRIX_PAYE' ? 'Prix payé *' : 'Prix contrat *'"
        suffix="€/t"
        hide-details
      />
    </div>
    <div
      v-if="typePrix && typePrix.code !== 'AUCUN'"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialCheckbox
        v-model="isPrixProvisoire"
        label="Prix provisoire"
        hide-details
      />
    </div>
    <div class="mb-4 mt-8 ml-5 action texte-gris-fonce">
      * Champs obligatoires
    </div>
    <v-card
      v-if="contratsVente.length === 0 && evolutionRendementNumtiers.rendementEnQuintauxParHectare == null"
      class="mx-6 pa-4 mb-3"
      color="var(--kaki)"
      elevation="0"
    >
      <div
        class="d-flex justify-center"
      >
        <span class="action kaki-color-text align-self-center">Pour voir la synthèse de vos contrats, veuillez d'abord confirmer votre rendement sur la page "Mes cultures".</span>
      </div>
    </v-card>

    <BaseMessage
      v-if="erreur"
      class="mb-4 mx-5"
      color="error"
      :message="erreur"
      text
      type="error"
    />
    <div class="d-flex justify-space-around">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        :loading="loading"
        class="pa-5"
        @click="saveContrat()"
      >
        Valider
      </AgrButton>
    </div>
    <InformationAbonnementModal
      v-if="isOpenModalInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
      code-feature="GESTION_CONTRATS"
      texte="Ajouter d'autres contrats que ceux affichés sur votre espace Culturial pour avoir une analyse globale de vos prix de vente."
      titre="Ajouter une vente"
      @close="isOpenModalInformationAbonnement = false"
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import AgrialCheckbox from '@/components/form/agrial-checkbox.vue'
import AgrialInput from '@/components/form/agrial-input.vue'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import { mapActions } from 'vuex'
import BaseMessage from '@/components/common/base-message.vue'
import { isEmptyString } from '@/utils/string'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'

export default {
  name: 'SaisieContratAdherentModal',
  components: {AgrButton, AgrialCheckbox, AgrialInput, AgrialInputNumber, AgrialSelect, BaseMessage, InformationAbonnementModal},
  props: {
    contrat: {
      type: Object,
      default: null
    },
    contratsVente: {
      type: Array,
      default: null
    },
    typeCultureSelected: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      isEmptyString: isEmptyString,
      loading: false,
      erreur: null,
      contratModifiable: {},
      libelle: null,
      typeContrat: null,
      poidsEnTonne: null,
      typePrix: null,
      prixPayeEnEuroParTonne: null,
      isPrixProvisoire: false,
      isOpenModalInformationAbonnement: false
    }
  },

  computed: {
    ...mapGetters({
      numtiers: 'adherent/numtiers',
      anneeRecolteActive: 'application/anneeRecolteActive',
      typesContrat: 'contratVente/typesContrat',
      typesPrix: 'contratVente/typesPrix',
      abonnements: 'adherent/abonnements',
      evolutionRendementNumtiers: 'rendement/evolutionRendementNumtiers',
    }),
    titreModal () {
      return this.contrat && this.contrat.id != null ? this.contrat.libelle : 'Ajouter une vente'
    },
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    isValid () {
      return this.libelle != null
      && !this.isEmptyString(this.libelle)
        && this.typeContrat != null
        && this.poidsEnTonne != null
        && this.typePrix != null
        && (((this.typePrix.code === 'PRIX_PAYE' || this.typePrix.code === 'PRIX_CONTRAT') && this.prixPayeEnEuroParTonne != null) || (this.typePrix.code === 'AUCUN' && this.prixPayeEnEuroParTonne == null))
    }
  },

  watch: {
    contrat: {
      handler () {
        this.libelle = this.contrat != null && this.contrat.id != null ? this.contrat.libelle : null
        this.typeContrat = this.contrat != null && this.contrat.id != null ? this.contrat.typeContrat : null 
        this.poidsEnTonne = this.contrat != null && this.contrat.id != null ? this.contrat.poidsEnTonne : null
        this.typePrix = this.contrat != null && this.contrat.id != null ? this.contrat.typePrix : null
        this.prixPayeEnEuroParTonne = this.contrat != null && this.contrat.id != null ? this.contrat.prixPayeEnEuroParTonne : null 
        this.libelle = this.contrat != null && this.contrat.id != null ? this.contrat.libelle : null 
        this.isPrixProvisoire = this.contrat != null && this.contrat.id != null ? this.contrat.isPrixProvisoire : null
      },
      immediate: true
    }
  },
  created () {
    this.getTypesContrat()
    this.getTypesPrix()
  },
  methods: {
    ...mapActions({
      createOrUpdateContratVente: 'contratVente/createOrUpdateContratVente',
      getContrats: 'contratVente/getContractualisation',
      getTypesContrat: 'contratVente/getTypesContrat',
      getTypesPrix: 'contratVente/getTypesPrix',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),
    saveContrat () {
      this.loading = true
      this.erreur = null
      this.contratModifiable.id = this.contrat!= null ? this.contrat.id : null
      this.contratModifiable.numtiers = this.numtiers
      this.contratModifiable.anneeRecolte = Number(this.anneeRecolteActive)
      this.contratModifiable.contratAgrial = false
      if (this.contrat!= null && this.contrat.id!= null) {
        let culture = this.contrat.cultures[0]
        culture.poidsEnTonne = this.poidsEnTonne
        this.contratModifiable.cultures = [culture]
      } else {
        this.contratModifiable.cultures = [{ typeCulture: this.typeCultureSelected, poidsEnTonne: this.poidsEnTonne }]
      }
      this.contratModifiable.dateCreation = this.contrat!= null && this.contrat.id != null ? this.contrat.dateCreation : null
      this.contratModifiable.userCreation = this.contrat!= null && this.contrat.id != null ? this.contrat.userCreation : null
      this.contratModifiable.libelle = this.libelle
      this.contratModifiable.typeContrat = this.typeContrat
      this.contratModifiable.poidsEnTonne = this.poidsEnTonne
      this.contratModifiable.typePrix = this.typePrix
      this.contratModifiable.prixPayeEnEuroParTonne = this.prixPayeEnEuroParTonne
      this.contratModifiable.isPrixProvisoire = this.isPrixProvisoire != null ? this.isPrixProvisoire: false
      this.createOrUpdateContratVente(this.contratModifiable)
        .catch(err => {
          this.erreur = err.response.data.message
          this.loading = false
        })
        .finally(() => {
          this.$emit('reload')
          this.onClose()
          this.loading = false
        })
    },
    loadContrats () {
      this.getContrats(this.typeCultureSelected.code)
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.onClose()
          this.loading = false
        })
    },
    onClose () {
      this.updateConfirm()
      this.$emit('close')
    },
    openModalAbonnement () {
      if (!this.isAbonneCulturial) {
        this.isOpenModalInformationAbonnement = !this.isOpenModalInformationAbonnement
        this.incrementerAccesSouscriptionAbonnement('GESTION_CONTRATS')
      }
    },

    updateConfirm () {
      this.libelle = null
      this.typeContrat = null
      this.poidsEnTonne = null
      this.typePrix = null
      this.prixPayeEnEuroParTonne = null
      this.isPrixProvisoire = false
    },
    updateTypePrix () {
      if (this.typePrix.code === 'AUCUN') {
        this.prixPayeEnEuroParTonne = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.prepend-icon {
  z-index: 100;
}
.cursor-pointer {
  ::v-deep.v-input--is-readonly input {
    cursor:pointer;
  }
}
.cursor-no-drop {
  ::v-deep.v-input--is-readonly input {
    cursor:no-drop;
  }
}
.kaki-color-text {
  color: #969A27;
}
</style>
